import script from "./vi-bar-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./vi-bar-chart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__